export const UserType = {
  LawFirm: 'LawFirm',
  LMS: 'LMS',
};
